
import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  Client,
  IJobModel,
  IJobItemModel,
  ILocationModel,
  IJobItemScheduleModel,
  IJobItemActivityModel
} from '@/services/api.service';

@Component({})
export default class PrintJobSheet extends Vue {
  public gid: string = '';
  public clientName: string = '';
  public jobNumber: string = '';
  public job: IJobModel | null = null;
  public jobLoaded: boolean = false;
  public rows: string[] = [];

  protected mounted() {
    // get the networks
    this.gid = this.$route.params.gid;

    for (let index = 0; index < 10; index++) {
      this.rows.push('' + index);
    }

    // @ts-ignore
    this.$Progress.start();
    this.fetchJobData(this.gid);
  }

  private async fetchJobData(jobgid: string) {
    const clientService = new Client(process.env.VUE_APP_API_URL, this.$http);
    const [theJob] = await Promise.all([clientService.getJob(jobgid)]);

    this.job = theJob;
    this.jobNumber = theJob.jobNumber || '';
    // this.jobItems = theJobItems;
    // this.locations = theLocations;

    this.jobLoaded = true;
    // this.jobItemsLoaded = true;
    // this.locationsLoaded = true;
  }
}
